export default __webpack_public_path__ + "static/media/reviewPatient.e3db6276.svg";